import React, { useEffect, useState } from "react";

const PreService = ({ onComplete }) => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (countdown <= 0) {
      if (onComplete) onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, onComplete]);

  return (
    <div
      style={{
        backgroundImage: "url('/pre-service.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        color: "#fff",
        padding: "2rem",
      }}
    >
      <h1
        style={{
          fontSize: "3rem",
          fontWeight: "bold",
          marginBottom: "1rem",
          textShadow: "2px 2px 8px #000",
        }}
      >
        True Gospel Chapel INTL
      </h1>

      <p style={{ fontSize: "1.5rem" }}>
        Service starts in {countdown} seconds
      </p>

      <audio controls loop>
        <source src="/intro-music.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default PreService;